import axios from 'axios';

import { shapeError } from './httpError';
import { readStorage, removeStorage } from './storage';
// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

axiosInstance.interceptors.request.use((config) => {
  // ★ 던지지 않는다. 사이트 데이터 저장이 막힌 브라우저에서는 `localStorage` 에 닿는 순간
  //   SecurityError 가 나는데, 여기서 던지면 **요청이 나가지도 않고** 모든 화면이
  //   «잠시 후 다시 시도» 가 됐다 — 로그인 전 공개 요청까지(f1-9).
  // 토큰이 없으면 머리글을 싣지 않는다(예전에는 `Bearer null` 을 실었다).
  const token = readStorage('accessToken');
  if (token) config.headers.setAuthorization(`Bearer ${token}`);
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error?.response?.status)
    if (error?.response?.status === 401) {
      removeStorage("accessToken");
      window.location.replace("/");
    }
    return Promise.reject(shapeError(error))
  },
);

export default axiosInstance;
